<template lang="pug">
    #filters-state
        .filters-header
            span {{ $t('insemination.filter.states') }}
            .svg-container(@click="resetFilterState", v-tooltip="$t('button.reset')")
                v-icon(name="refresh")
        .filter-element.nothing(v-if="$route.name !== 'milk-inspection'", @click="updateFilterState('nothing')", v-bind:class="[{ 'unselected' : filterStates.indexOf('nothing') < 0} ]")
            .svg-container.flex-grow-1
                v-icon(v-if="filterStates.indexOf('nothing') > -1", name="check-sqt")
            span.flex-grow-1 {{ $t('animal.state.nothing') }}
            span.flex-grow-10 {{ countAnimalByFecondity('nothing') }}
        .filter-element.calved(@click="updateFilterState('calved')", v-bind:class="[{ 'unselected' : filterStates.indexOf('calved') < 0}]")
            .svg-container.flex-grow-1
                v-icon(v-if="filterStates.indexOf('calved') > -1", name="check-sqt")
            span.flex-grow-1 {{ $t('animal.state.calved') }}
            span.flex-grow-10 {{ countAnimalByFecondity('calved') }}
        .filter-element.monitor(@click="updateFilterState('monitor')", v-bind:class="[{ 'unselected' : filterStates.indexOf('monitor') < 0}]")
            .svg-container.flex-grow-1
                v-icon(v-if="filterStates.indexOf('monitor') > -1", name="check-sqt")
            span.flex-grow-1 {{ $t('animal.state.monitor') }}
            span.flex-grow-10 {{ countAnimalByFecondity('monitor') }}
        .filter-element.inseminate(@click="updateFilterState('inseminate')", v-bind:class="[{ 'unselected' : filterStates.indexOf('inseminate') < 0}]")
            .svg-container.flex-grow-1
                v-icon(v-if="filterStates.indexOf('inseminate') > -1", name="check-sqt")
            span.flex-grow-1 {{ $t('animal.state.inseminate') }}
            span.flex-grow-10 {{ countAnimalByFecondity('inseminate') }}
        .filter-element.ultrasound(@click="updateFilterState('ultrasound')", v-bind:class="[{ 'unselected' : filterStates.indexOf('ultrasound') < 0}]")
            .svg-container.flex-grow-1
                v-icon(v-if="filterStates.indexOf('ultrasound') > -1", name="check-sqt")
            span.flex-grow-1 {{ $t('animal.state.ultrasound') }}
            span.flex-grow-10 {{ countAnimalByFecondity('ultrasound') }}
        .filter-element.inseminated(@click="updateFilterState('inseminated')", v-bind:class="[{ 'unselected' : filterStates.indexOf('inseminated') < 0}]")
            .svg-container.flex-grow-1
                v-icon(v-if="filterStates.indexOf('inseminated') > -1", name="check-sqt")
            span.flex-grow-1 {{ $t('animal.state.inseminated') }}
            span.flex-grow-10 {{ countAnimalByFecondity('inseminated') }}
        .filter-element.non-inseminated(@click="updateFilterState('non-inseminated')", v-bind:class="[{ 'unselected' : filterStates.indexOf('non-inseminated') < 0}]")
            .svg-container.flex-grow-1
                v-icon(v-if="filterStates.indexOf('non-inseminated') > -1", name="check-sqt")
            span.flex-grow-1 {{ $t('animal.state.non-inseminated') }}
            span.flex-grow-10 {{ countAnimalByFecondity('non-inseminated') }}
        .filter-element.to-dry-up(@click="updateFilterState('to-dry-up')", v-bind:class="[{ 'unselected' : filterStates.indexOf('to-dry-up') < 0}]")
            .svg-container.flex-grow-1
                v-icon(v-if="filterStates.indexOf('to-dry-up') > -1", name="check-sqt")
            span.flex-grow-1 {{ $t('animal.state.to-dry-up') }}
            span.flex-grow-10 {{ countAnimalByFecondity('to-dry-up') }}
        .filter-element.dried(@click="updateFilterState('dried')", v-bind:class="[{ 'unselected' : filterStates.indexOf('dried') < 0}]")
            .svg-container.flex-grow-1
                v-icon(v-if="filterStates.indexOf('dried') > -1", name="check-sqt")
            span.flex-grow-1 {{ $t('animal.state.dried') }}
            span.flex-grow-10 {{ countAnimalByFecondity('dried') }}
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'FilterState',
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'selectedFarm',
            'countAnimalByFecondity',
            'filterStates'
        ])
    },
    methods: {
        ...mapMutations(['updateFilterState', 'resetFilterState'])
    }
}
</script>

<style scoped>
</style>
